import { EntAnimalBreedFilter } from "../../../models/filters/animalBreedFilter";
import { EntAnimalBreed } from "../../../models/handBooks/animalBreed";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const animalBreadApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getAnimalBreedList: builder.query<ResponseDataGet<EntAnimalBreed>, EntAnimalBreedFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.animalbreed }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getAnimalBreedById: builder.query<ResponseDataGet<EntAnimalBreed>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.animalbreed }/${ id }`,
		method: 'GET'
	  })
	}),
	addAnimalBreed: builder.mutation<ResponseDataGet<EntAnimalBreed>, EntAnimalBreed>({
	  query: (body) => ({
		url: `${ Paths.handbooks.animalbreed }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editAnimalBreed: builder.mutation<ResponseDataGet<EntAnimalBreed>, EntAnimalBreed>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.animalbreed }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteAnimalBreed: builder.mutation<ResponseDataGet<EntAnimalBreed>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.animalbreed }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddAnimalBreedMutation,
  useDeleteAnimalBreedMutation,
  useEditAnimalBreedMutation,
  useLazyGetAnimalBreedListQuery
} = animalBreadApi;
